export default __webpack_public_path__ + "static/media/metabolism.bf1849a2.svg";